import axios from "axios";

let app = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 50000,
  headers: {
    senha: "gv3kuvWjm%W2yq4&8%j",
  },
});

export default app;
